var e={Badge:"Badge__Badge-7Mv",green:"Badge__green-yoo",blue:"Badge__blue-m33",red:"Badge__red-4gF",purple:"Badge__purple-dMf",orange:"Badge__orange-m9j"};export{e as default};
